const $_documentContainer = document.createElement('template');
$_documentContainer.setAttribute('style', 'display: none;');

$_documentContainer.innerHTML = `<dom-module id="cbar-header-shared-styles">
  <template>
    <style>
      [hidden] {
        display: none;
      }

      a {
        text-decoration: none;
        color: initial;
        outline: none;
        pointer-events: auto;
      }
    </style>
  </template>
</dom-module>`;

document.head.appendChild($_documentContainer.content);
